import React, { FC, MouseEvent } from 'react';
import { Tag as ChakraUITag, TagLabel, TagCloseButton } from '@chakra-ui/react';
import { TagVariant, TagSize } from './types';
import { Icon, IconProps } from '../Icon';

export interface TagProps {
  closeClick?: (event: MouseEvent) => void;
  variant?: TagVariant;
  colorScheme?: string;
  tagLabel?: string | React.ReactNode;
  isClosable?: boolean;
  size?: TagSize;
  children?: React.ReactNode;
  onClick?: (event: MouseEvent) => void;
  onMouseDown?: (event: MouseEvent) => void;
  textStyle?: string;
  isRound?: boolean;
  leftIcon?: IconProps;
  rightIcon?: IconProps;
  leftImage?: React.ReactNode;
  rightImage?: React.ReactNode;
  as?: React.ElementType;
  className?: string;
  ariaLabel?: string;
}

export const Tag: FC<TagProps> = ({
  closeClick,
  onClick,
  variant,
  colorScheme,
  tagLabel,
  isClosable,
  isRound,
  size,
  children,
  leftIcon,
  rightIcon,
  leftImage,
  rightImage,
  onMouseDown,
  className,
  ariaLabel,
}: TagProps) => {
  /**
   * DOM
   */
  const isInteractive = !!onClick || !!onMouseDown;
  return (
    <ChakraUITag
      variant={variant}
      size={size}
      colorScheme={colorScheme}
      data-object-type="tag"
      {...(isRound && { rounded: 'full' })}
      {...(isInteractive && { as: 'button', cursor: 'pointer' })}
      {...(onClick && { onClick })}
      {...(onMouseDown && { onMouseDown })}
      {...(ariaLabel && { 'aria-label': ariaLabel })}
      className={className}
    >
      {leftImage || (leftIcon && <Icon {...leftIcon} />)}
      {!!tagLabel && <TagLabel>{tagLabel}</TagLabel>}
      {children}
      {rightImage || (rightIcon && <Icon {...rightIcon} />)}
      {!!isClosable && <TagCloseButton onClick={closeClick} {...(isRound && { rounded: 'full' })} />}
    </ChakraUITag>
  );
};
